import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-223dd4f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-input" }
const _hoisted_2 = { class: "search-icon" }
const _hoisted_3 = ["placeholder", "value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Show results ", -1))
const _hoisted_5 = ["onClick"]

import { ref, watchEffect } from "vue"
import { SearchIcon } from '@zhuowenli/vue-feather-icons'
import { Dropdown } from "bootstrap"

interface SearchResult {
   id?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
    modelValue: {},
    searchResults: {},
    placeholder: {},
    disabled: { type: Boolean }
  },
  emits: [
  'update:modelValue',
  'resultSelected',
  'focus',
  'blur',
  'keydown',
],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  focus,
  reset
})

const inputRef = ref<HTMLInputElement>()
const dropdownRef = ref<HTMLElement>()
const dropdownMenuRef = ref<HTMLElement>()

function updateModelValue(e: Event) {
  emit('update:modelValue', (e.target as HTMLInputElement).value)
}

function clearModelValue() {
  emit('update:modelValue', '')
}

watchEffect(() => {
  showDropdown(props.searchResults?.length > 0)
})

function searchResultSelected(item: SearchResult) {
  clearModelValue()
  emit('resultSelected', item.id)
  showDropdown(false)
}

function showDropdown(show: boolean) {
  if (dropdownRef.value) {
    const dropdown = new Dropdown(dropdownRef.value)
    if (show) {
      dropdown.show()
    }
    else {
      dropdown.hide()
    }
  }
}

function isDropdownShown() {
  return dropdownMenuRef.value?.classList.contains('show') ?? false
}

function focusDropdown() {
  const firstButton = dropdownRef.value?.querySelector('button.dropdown-item') as HTMLButtonElement | null
  firstButton?.focus()
}

function inputKeyDown(e: KeyboardEvent) {
  switch (e.key) {
    case 'Enter': {
      if (!isDropdownShown()) {
        showDropdown(true)
        e.preventDefault()
        e.stopPropagation()
      }
      else {
        focusDropdown()
        e.preventDefault()
        e.stopPropagation()
      }
      break
    }
    case 'Escape': {
      if (isDropdownShown()) {
        showDropdown(false)
        e.stopPropagation()
      }
      else if (props.modelValue.length > 0) {
        clearModelValue()
        e.stopPropagation()
      }
      break
    }
    case 'ArrowDown': {
      if (props.modelValue.length > 0) {
        e.preventDefault()
        focusDropdown()
      }
      break
    }
  }
}

function focus() {
  inputRef.value?.focus()
}

function reset() {
  showDropdown(false)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_unref(SearchIcon), { size: "1x" })
    ]),
    _createElementVNode("input", _mergeProps({
      type: "textbox",
      ref_key: "inputRef",
      ref: inputRef,
      class: "form-control",
      placeholder: props.placeholder,
      value: props.modelValue
    }, { disabled: props.disabled }, {
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (emit('focus'))),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (emit('blur'))),
      onInput: updateModelValue,
      onKeydown: inputKeyDown
    }), null, 16, _hoisted_3),
    _createElementVNode("div", {
      ref_key: "dropdownRef",
      ref: dropdownRef,
      class: "dropdown"
    }, [
      _hoisted_4,
      _createElementVNode("ul", {
        ref_key: "dropdownMenuRef",
        ref: dropdownMenuRef,
        class: "dropdown-menu"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.searchResults, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "dropdown-item",
              onClick: ($event: any) => (searchResultSelected(item))
            }, [
              _renderSlot(_ctx.$slots, "default", { item: item })
            ], 8, _hoisted_5)
          ]))
        }), 128))
      ], 512)
    ], 512)
  ]))
}
}

})